<script lang="ts">
    import {
        BicycleIcon,
        GearIcon,
        LoadingIcon,
        TripIcon,
    } from "@anyways-open/common-svgs";
    import { get } from "svelte/store";
    import Layer from "../Layer.svelte";
    import { onMount } from "svelte";
    import { v4 as uuidv4 } from "uuid";
    import type { Feature } from "geojson";
    import * as turf from "@turf/turf";
    import { Utils } from "../../../../Utils";
    import { appManager } from "../../../../AppManager";
    import type { TripsScenarioManager } from "./TripsScenarioManager";
    import MatrixRow from "./matrices/MatrixRow.svelte";
    
    export let manager: TripsScenarioManager;
    let expandedStore = manager.getExpandedStore();
    let nameStore = manager.name;
    let statisticsStore = manager.getStats();
    let matrixLayerManagersStore = manager.getMatrixLayers();
    let isBusyStore = appManager.getBusyWorkManager().getIsBusyStore();

    matrixLayerManagersStore.subscribe((ms) => {
        //console.log(`matrices in store: ${ms.length}`);
    });

    isBusyStore.subscribe(x => {
        //console.log(`Busystore is ${x}`);
    });

    let bicycleSafety = "-";
    let bicycleComfort = "-";
    let distance = "-";
    let time = "-";
    statisticsStore.subscribe((stats) => {
        bicycleSafety = "-";
        bicycleComfort = "-";
        distance = "-";
        time = "-";
        if (typeof $statisticsStore.bicycleScores.comfort !== "undefined") {
            bicycleComfort = `${
                Math.round($statisticsStore.bicycleScores.comfort * 100) / 100
            }`;
        }
        if (typeof $statisticsStore.bicycleScores.safety !== "undefined") {
            bicycleSafety = `${
                Math.round($statisticsStore.bicycleScores.safety * 100) / 100
            }`;
        }
        if (typeof $statisticsStore.distance !== "undefined") {
            distance = `${Math.round($statisticsStore.distance / 10) / 100}`;
        }
        if (typeof $statisticsStore.time !== "undefined") {
            const hours = Math.floor($statisticsStore.time / 3600);
            const minutes = Math.floor(
                ($statisticsStore.time - hours * 3600) / 60,
            );

            time = `${Math.round(hours)}h ${Math.round(minutes)}m`;
        }
    });

    let canSave = false;
    let overviewExpanded = true;

    const onAddMatrix = async () => {
        await manager.onAddNewMatrixClick();
    };

    function offerAllTripsAsDownload() {
        const features: Feature[] = manager.getFusedFeatures();
        const featureCollection = turf.featureCollection(features);
        new Utils().offerContentsAsDownloadableFile(
            JSON.stringify(featureCollection, null, "  "),
            "Trips.geojson",
            {
                mimetype: "application/vnd.geo+json",
            },
        );
    }
</script>

<Layer canRemove={false} {canSave} canVisible={false} expanded={$expandedStore}>
    <div class="svg-icon-sm svg-icon-grey" slot="icon">
        <TripIcon />
    </div>

    <div class="d-flex justify-content-between" slot="title">
        <h3
            bind:innerHTML={$nameStore}
            class="pb-1"
            contenteditable="true"/>

        {#if $isBusyStore}
            <div class="d-flex" style="height: 25px;">
                <LoadingIcon
                    style="margin-left: 25px; height: 25px; fill: black;" />
            </div>
        {/if}

        <div class="btn badge badge-rounded-circle badge-success-soft ms-1">
            <i class="fe fe-download" on:click={offerAllTripsAsDownload} />
        </div>
    </div>

    <div class="container ps-2 pe-0" slot="content">
        {#if overviewExpanded}
            <div class="row gx-0 pb-1 pe-0 fs-tool">
                <div class="col-6">
                    <div class="d-flex {distance === '-' ? 'low-opacity' : ''}">
                        <div class="svg-icon-sm svg-icon-grey pe-1">
                            <TripIcon />
                        </div>
                        <div>{distance} km</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="d-flex {time === '-' ? 'low-opacity' : ''}">
                        <div class="svg-icon-sm svg-icon-grey pe-1">
                            <TripIcon />
                        </div>
                        <div>{`${time}`}</div>
                    </div>
                </div>
            </div>
            <div class="row gx-0 pb-1 pe-0 fs-tool">
                <div class="col-6">
                    <div
                        class="d-flex {bicycleSafety === '-'
                            ? 'low-opacity'
                            : ''}">
                        <div class="svg-icon-sm svg-icon-grey pe-1">
                            <BicycleIcon />
                        </div>
                        <div>{bicycleSafety}</div>
                    </div>
                </div>
            </div>
        {/if}
        <div class="row py-1 px-0 gx-0 fs-tool">
            <div class="d-flex">
                <div class="svg-icon-sm svg-icon-grey pe-1">
                    <GearIcon />
                </div>
                <div>Matrices</div>
                <div
                    class="btn badge badge-rounded-circle badge-success-soft ms-auto"
                    on:click={() => onAddMatrix()}>
                    <i class="fe fe-plus" />
                </div>
            </div>
        </div>
        <div class="container ps-2 pe-0">
            {#each $matrixLayerManagersStore as matrixLayer}
                <MatrixRow bind:manager={matrixLayer} />
            {/each}
        </div>
    </div>
</Layer>

<style>
    .badge {
        margin-top: 2px;
    }

    .low-opacity {
        opacity: 0.25;
    }
</style>
